import axios from "axios";
import React, { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import toastr from "../../../utils/toast";
import ClientProsModal from "./ClientProsModal";

function ExistingClient({ onClose, company_id }) {
  const { setGlobalLoading, token } = useOutletContext();
  const [existingClient, setExistingClient] = useState([]);
  const [showClientProsModal, setShowClientProsModal] = useState(false);

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  async function getclient_details(company_id) {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/clients/get_client_details/`,
        { id: company_id },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      setExistingClient(response?.data[0]);
      console.log(response?.data[0]);
    } catch (error) {
      console.log(error);
      toastr.error(error?.response?.data?.message);
    }
  }

  useEffect(() => {
    getclient_details(company_id);
  }, [company_id]);

  return (
    <>
      {showClientProsModal && (
        <ClientProsModal
          onClose={(e) => {
            console.log(e);
            setShowClientProsModal(false);
            if (e == 1) {
              onClose?.();
            }
          }}
          data={existingClient}
        />
      )}
      <div className="modal fade show d-block " tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered modal-md">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Existing Client Detected</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="p-2 d-flex align-items-center justify-content-between border border-primary bg-primary-100 br-5 mb-4">
                <div className="overflow-hidden">
                  <div className="d-flex align-items-center mb-2">
                    <span className="me-2">
                      <i className="fa-solid fa-briefcase text-primary fs-20"></i>
                    </span>
                    <span className="text-dark ms-1">
                      <span className="fw-medium fs-12 me-1">
                        {existingClient?.company_name}
                      </span>
                      is already a client developed by
                      <span className="fw-medium fs-12 me-1 text-primary ms-1">
                        {existingClient?.bd_by}
                      </span>
                      <span className="">{`(${existingClient?.bd_designation})`}</span>
                      <p className="text-muted fs-10 op-9 mt-1">
                        Client Type : {existingClient?.client_type} | Industry :{" "}
                        {existingClient?.industrymaster}
                      </p>
                    </span>
                  </div>
                  <p className="text-dark op-9">
                    Would you like to add a <b>prospective search</b> within
                    this client's pipeline?
                  </p>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-dark"
                onClick={() => {
                  setShowClientProsModal(true);
                }}
              >
                Yes, add a search
              </button>
              <button
                type="button"
                className="btn btn-secondary ms-1"
                onClick={() => {
                  onClose?.();
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ExistingClient;
